import 'babel-polyfill'
// Import System requirements
import Vue from 'vue'
import VueRouter from 'vue-router'

import { sync } from 'vuex-router-sync'
import routes from './routes'
import store from './store'
/* import config from './config' */
import fullDateFormatter from './utils/fullDateFormatter'

// Import Helpers for filters
import { domain, count, prettyDate, pluralize, dateFormatter, dateFormatterLastActivity } from './filters'
import * as VueGoogleMaps from 'vue2-google-maps'

// Import Views - Top level
import AppView from './components/App.vue'

// Import Install and register helper items
Vue.filter('count', count)
Vue.filter('domain', domain)
Vue.filter('prettyDate', prettyDate)
Vue.filter('pluralize', pluralize)
Vue.filter('dateFormatter', dateFormatter)
Vue.filter('dateFormatterLastActivity', dateFormatterLastActivity)
Vue.filter('fullDateFormatter', fullDateFormatter)

// Routerx
Vue.use(VueRouter)

// Google map
Vue.use(VueGoogleMaps, {
  load: {
   // key: 'AIzaSyDYpVnlol0frsgnK_FqWEl0m211HX2V7Hk',
    key: 'AIzaSyClu1DjpsJ0csq-nuaUjz9XbnBDJcClSGk',
      // libraries: 'places', //// If you need to use place input
  },
})
if (window) {
   window.console.log = function () {}
}
console.log('MAIIIIIIIIIIIIIIIIN')
/* // Spacedog
if (location.origin.indexOf('servicecomplet-bo-rec.suez.fr') > -1) { // eslint-disable-line no-undef
  SpaceDog.initializeWithBaseUrl('https://servicecompletwsrec.suez.fr')
} else if (location.origin.indexOf('servicecomplet-bo-preprod.suez.fr') > -1) {  // eslint-disable-line no-undef
  SpaceDog.initializeWithBaseUrl('https://servicecompletwspreprod.suez.fr')
} else if (location.origin.indexOf('servicecomplet-bo.suez.fr') > -1) {  // eslint-disable-line no-undef
  SpaceDog.initializeWithBaseUrl('https://servicecompletws.suez.fr')
} else {
  SpaceDog.initializeWithBaseUrl('https://servicecompletwsdev.suez.fr')
  // SpaceDog.initializeWithBaseUrl('https://servicecompletwsrec.suez.fr')
} */

// SpaceDog.initializeWithBaseUrl('https://servicecompletws.suez.fr')
//SpaceDog.initializeWithBaseUrl('https://servicecompletwsrec.suez.fr')

// Routing logic
var router = new VueRouter({
  routes: routes,
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  },
})

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
  // window.console.log('Transition', transition)
  if (to.name !== 'Login' && to.name !== 'ResetPassword' && !store.state.login.loggedIn) {
    window.console.log(`Not authenticated ${to.name !== 'Login'} && ${store.state.login.loggedIn} `)
    next({
      path: '/login',
      query: { redirect: to.fullPath },
    })
  } else {
    next()
  }
})

sync(store, router)

// Start out app!
// eslint-disable-next-line no-new
new Vue({
  el: '#root',
  router: router,
  store: store,
  render: h => h(AppView),
})




// WEBPACK FOOTER //
// ./src/main.js